import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Check if authentication was successful
    const params = new URLSearchParams(window.location.search);
    if (params.get('error')) {
      navigate('/login?error=' + params.get('error'));
    } else if (user) {
      // User is authenticated, redirect to appropriate dashboard
      navigate(user.role === 'admin' ? '/admin' : '/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mb-4"></div>
        <p className="text-lg text-gray-600">Menyelesaikan login dengan Google...</p>
      </div>
    </div>
  );
}
